import occupancyIcon from 'assets/images/icons/OCCUPANCY.svg';
import PropTypes from 'prop-types';
import { setChartPopUp } from 'stores/sensor/sensorStore';
import { brandColors } from 'types/colors';

import FormattedChart from './FormattedChart';

export const demandMeasurements = [
  { field: 'occupancy', label: 'Occupancy', color: brandColors.BLACK },
  { field: 'thermal_justified', label: 'Thermal justified', color: brandColors.BLUE },
  { field: 'thermal_saveable', label: 'Thermal saveable', color: brandColors.GREEN },
  { field: 'thermal_requested', label: 'Thermal requested', color: brandColors.RED },
  { field: 'air_justified', label: 'Air justified', color: brandColors.BLUE },
  { field: 'air_saveable', label: 'Air saveable', color: brandColors.GREEN },
  { field: 'air_requested', label: 'Air requested', color: brandColors.RED },
];

const getAverageDataset = (chart, field, label, color) => {
  const parameterLetter = field.split('_').pop().charAt(0).toUpperCase();
  return {
    field,
    label,
    color,
    data: (chart[field] || []).map(point => ({
      ...point,
      value: point.value >= 1 ? Math.round(point.value) : Math.round(point.value * 10) / 10,
      parameterLetter,
    })),
  };
};

const Charts = ({ chart = {}, selectedMeasurements = [] }) => {
  const datasets = selectedMeasurements
    .map(selectedMeasurement => {
      const selectedMeasurementConfig = demandMeasurements.find(measurement => measurement.field === selectedMeasurement);
      return getAverageDataset(chart, selectedMeasurement, selectedMeasurementConfig?.label, selectedMeasurementConfig?.color);
    })
    .filter(dataset => dataset.data.length > 0);
  const occupancyDataset = datasets.find(dataset => dataset.field === 'occupancy');
  const occupancyYAxisRange = {
    min: 0,
    max: Math.max(100, ...(occupancyDataset?.data.map(point => point.value) ?? [])),
  };

  return (
    <FormattedChart
      title={selectedMeasurements.length === 1 ? datasets[0]?.label : 'Building demand'}
      datasets={datasets}
      isRange={false}
      yAxisRanges={datasets.map(dataset => (dataset.field === 'occupancy' ? occupancyYAxisRange : { min: 0, max: 100 }))}
      setChartPopUp={setChartPopUp}
      formatTooltipValue={(value, { seriesIndex, dataPointIndex, w }) => {
        const point = w?.config?.series?.[seriesIndex]?.data?.[dataPointIndex];
        const thresholdCount = `${point?.thresholdCount ?? 0}/${point?.totalCount ?? 0}`;

        return `~${value}% ${thresholdCount}`;
      }}
      formatDataLabelValue={(value, { seriesIndex, dataPointIndex, w }) => {
        const point = w?.config?.series?.[seriesIndex]?.data?.[dataPointIndex];
        const isOccupancy = w?.config?.series?.[seriesIndex]?.name === 'Occupancy';
        const label = `~${value}%${isOccupancy ? '' : ` ${point?.parameterLetter ?? ''}`}`;
        const thresholdCount = `(${point?.thresholdCount ?? 0}/${point?.totalCount ?? 0})`;

        return `${label}\n${thresholdCount}`;
      }}
      dataLabelIcon={occupancyIcon}
      dataLabelIconSeries={datasets.map(dataset => dataset.field === 'occupancy')}
    />
  );
};

Charts.propTypes = {
  chart: PropTypes.object,
  selectedMeasurements: PropTypes.arrayOf(PropTypes.string),
};

export default Charts;
